/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum BookingParticipantSubjectRole {
  MainSubject = 'MainSubject',
  LegalGuardian = 'LegalGuardian'
}
